module.exports = __webpack_public_path__ + "static/media/Maple_Forest.53c8f272.pdf";